export default __webpack_public_path__ + "static/media/rate-overall.2e6cf84a.svg";